import React from 'react'

const PrivacyPolicyPage = () => {
  return (
    <div className="bg-gray-50 min-h-screen p-6 sm:p-10 lg:px-20 300px:mt-[65px] 1280px:mt-0">
      <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-lg p-8">
        <h1 className="text-[20px] ProxymaBold text-gray-800 mb-6 text-center">
          Privacy Policy
        </h1>
        <p className="text-gray-600 mb-6 ProxymaBold">
          <strong>Effective Date:</strong> 20.01.2020
        </p>
        <p className="text-gray-600 mb-6 ProxymaRegular">
          At <strong className='ProxymaBold'>Decorationbd.com</strong>, we value your trust and are
          committed to protecting your privacy. This Privacy Policy outlines
          how we collect, use, store, and share your personal information when
          you interact with our website, services, and products.
        </p>

        <h2 className="text-[18px] ProxymaBold text-gray-800 mb-4">
          1. Information We Collect
        </h2>
        <p className="text-gray-600 mb-4 ProxymaRegular">
          We collect the following types of information to provide and improve
          our services:
        </p>
        <h3 className="text-[18px] ProxymaSemiBold text-gray-700 mb-2">a. Personal Information</h3>
        <ul className="list-disc pl-6 text-gray-600 mb-4 ProxymaRegular">
          <li>Your name</li>
          <li>Email address</li>
          <li>Phone number</li>
          <li>Billing and shipping addresses</li>
          <li>Payment details (processed securely by third-party providers)</li>
        </ul>

        <h3 className="text-[18px] ProxymaSemiBold text-gray-700 mb-2">b. Non-Personal Information</h3>
        <ul className="list-disc pl-6 text-gray-600 mb-4 ProxymaRegular">
          <li>Browser type and device information</li>
          <li>IP address</li>
          <li>Pages visited and time spent on the site</li>
          <li>Cookies and tracking technologies</li>
        </ul>

        <h2 className="text-[18px] ProxymaBold text-gray-800 mb-4">
          2. How We Use Your Information
        </h2>
        <ul className="list-disc pl-6 text-gray-600 mb-4 ProxymaRegular">
          <li>To process and deliver your orders</li>
          <li>To personalize your shopping experience</li>
          <li>To communicate with you about orders, promotions, or updates</li>
          <li>To improve our website, products, and customer service</li>
          <li>To comply with legal requirements</li>
        </ul>

        <h2 className="text-[18px] ProxymaBold text-gray-800 mb-4">
          3. How We Share Your Information
        </h2>
        <p className="text-gray-600 mb-4 ProxymaRegular">
          We do not sell, trade, or rent your personal information to third
          parties. However, we may share your information with trusted third
          parties in the following scenarios:
        </p>
        <ul className="list-disc pl-6 text-gray-600 mb-4 ProxymaRegular">
          <li>
            <strong className='ProxymaSemiBold'>Service Providers:</strong> For payment processing, order
            fulfillment, and delivery services.
          </li>
          <li>
            <strong className='ProxymaSemiBold'>Legal Obligations:</strong> To comply with applicable laws,
            regulations, or legal requests.
          </li>
        </ul>

        <h2 className="text-[18px] ProxymaBold text-gray-800 mb-4">
          4. Cookies and Tracking Technologies
        </h2>
        <p className="text-gray-600 mb-4 ProxymaRegular">
          StayPureBD.com uses cookies and similar technologies to enhance your
          browsing experience, remember your preferences, and analyze website
          traffic. You can disable cookies through your browser settings, though
          some features of the site may not function properly.
        </p>

        <h2 className="text-[18px] ProxymaBold text-gray-800 mb-4">
          5. Data Security
        </h2>
        <p className="text-gray-600 mb-4 ProxymaRegular">
          We take reasonable precautions to protect your personal information.
          Measures include:
        </p>
        <ul className="list-disc pl-6 text-gray-600 mb-4 ProxymaRegular">
          <li>SSL encryption for secure data transmission</li>
          <li>Regular system monitoring for vulnerabilities</li>
          <li>
            Restricting access to personal data to authorized personnel
          </li>
        </ul>
        <p className="text-gray-600 mb-4 ProxymaRegular">
          Despite these measures, no method of transmission over the Internet is
          100% secure.
        </p>

        <h2 className="text-[18px] ProxymaBold text-gray-800 mb-4">
          6. Your Rights
        </h2>
        <p className="text-gray-600 mb-4 ProxymaRegular">
          You have the following rights concerning your personal data:
        </p>
        <ul className="list-disc pl-6 text-gray-600 mb-4 ProxymaRegular">
          <li>
            <strong className='ProxymaSemiBold'>Access:</strong> Request a copy of the data we hold about
            you.
          </li>
          <li>
            <strong className='ProxymaSemiBold'>Correction:</strong> Update inaccurate or incomplete
            information.
          </li>
          <li>
            <strong className='ProxymaSemiBold'>Deletion:</strong> Request the deletion of your data,
            subject to legal or contractual obligations.
          </li>
          <li>
            <strong className='ProxymaSemiBold'>Opt-Out:</strong> Unsubscribe from promotional
            communications.
          </li>
        </ul>
        <p className="text-gray-600 mb-4 ProxymaRegular">
          To exercise these rights, please contact us at [mnhodarajib@gmail.com].
        </p>

        <h2 className="text-[18px] ProxymaBold text-gray-800 mb-4">
          7. Third-Party Links
        </h2>
        <p className="text-gray-600 mb-4 ProxymaRegular">
          Our website may contain links to external sites. We are not
          responsible for the privacy practices or content of those sites.
          Please review their privacy policies when visiting them.
        </p>

        <h2 className="text-[18px] ProxymaBold text-gray-800 mb-4">
          8. Changes to This Privacy Policy
        </h2>
        <p className="text-gray-600 mb-4 ProxymaRegular">
          We reserve the right to update this Privacy Policy at any time.
          Changes will be effective immediately upon posting to our website.
          Please review it periodically to stay informed.
        </p>

        <h2 className="text-[18px] ProxymaBold text-gray-800 mb-4">
          9. Contact Us
        </h2>
        <p className="text-gray-600 mb-4 ProxymaRegular">
          If you have any questions or concerns about this Privacy Policy or how
          we handle your data, please contact us:
        </p>
        <ul className="list-disc pl-6 text-gray-600 mb-4 ProxymaRegular">
          <li>
            <strong className='ProxymaSemiBold'>Email:</strong> mnhodarajib@gmail.com
          </li>
          <li>
            <strong className='ProxymaSemiBold'>Phone:</strong> +8801717381296
          </li>
          <li>
            <strong className='ProxymaSemiBold'>Address:</strong> Mymensingh,Dhaka,Bangladesh
          </li>
        </ul>
        <p className="text-gray-600 text-center ProxymaRegular">
          Thank you for trusting <strong className='ProxymaSemiBold'>Decorationbd.com</strong> for your
           needs.
        </p>
      </div>
    </div>
  )
}

export default PrivacyPolicyPage
